import type { QuestionHelperProps } from './interfaces';
import QuestionMark from 'Assets/images/question-mark.svg';
import { PopOverMenu } from 'Components/shared/PopOverMenu';
import React from 'react';
import { Styled } from './index.styles';

export const QuestionHelper: React.FC<QuestionHelperProps> = ({
  content,
  testid,
}) => {
  const [showPopover, setShowPopOver] = React.useState(false);

  return (
    <Styled.QuestionMarkContainer>
      <PopOverMenu
        content={<Styled.PopoverContent>{content}</Styled.PopoverContent>}
        trigger={
          <Styled.IconQuestionMark
            data-testid={`${testid}-popupQuestionMark`}
            src={QuestionMark}
            onClick={() => setShowPopOver(!showPopover)}
          />
        }
        position="bottom left"
        show={showPopover}
        onOutsideClick={() => setShowPopOver(false)}
      />
    </Styled.QuestionMarkContainer>
  );
};
